import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    shipments: [],
    loading: false,
    error: null,
  }),
  getters: {
    allShipments: state => state.shipments,
    activeShipments: state => state.shipments.filter(s => s.deliveryStatus === 'active'),
    completedShipments: state => state.shipments.filter(s => s.deliveryStatus === 'completed'),
    paidShipments: state => state.shipments.filter(s => s.paymentStatus === 'paid'),
    unpaidShipments: state => state.shipments.filter(s => s.paymentStatus !== 'paid'),
    shipmentCount: state => state.shipments.length,
    getShipmentById: state => id => state.shipments.find(s => s.id === id),
  },
  mutations: {
    setShipments(state, data) { state.shipments = data; },
    addShipment(state, shipment) { state.shipments.push({ ...shipment, images: shipment.images || [] }); },
    updateShipment(state, shipment) {
      const index = state.shipments.findIndex(s => s.id === shipment.id);
      if(index !== -1) state.shipments.splice(index, 1, { ...state.shipments[index], ...shipment });
    },
    removeShipment(state, id) { state.shipments = state.shipments.filter(s => s.id !== id); },
    addShipmentImages(state, { id, images }) {
      const shipment = state.shipments.find(s => s.id === id);
      if(shipment) shipment.images.push(...images);
    },
    setLoading(state, loading) { state.loading = loading; },
    setError(state, error) { state.error = error; },
  },
  actions: {
    async fetchShipments({ commit }) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const res = await axios.get('/api/shipments');
        if (res.data?.error) {
          commit('setError', res.data.error);
          if(this._vm?.$toast) this._vm.$toast.error('Failed to fetch shipments: ' + JSON.stringify(res.data.error));
        } else {
          commit('setShipments', res.data);
        }
      } catch(err) {
        const msg = err.response?.data?.error || err.response?.data?.message || err.message;
        commit('setError', msg);
        if(this._vm?.$toast) this._vm.$toast.error('Failed to fetch shipments: ' + msg);
        console.error('Fetch Shipments Error:', err);
      } finally {
        commit('setLoading', false);
      }
    },

async addShipment({ commit }, shipment) {
  commit('setLoading', true);
  commit('setError', null);
  try {
    const res = await axios.post('/api/shipments', shipment);

    // Success only if request succeeds
    commit('addShipment', res.data);
    console.log('Add Shipment Response:', res.data); // Log response
    if(this._vm?.$toast) this._vm.$toast.success('Shipment added successfully!');

  } catch(err) {
    // Log the full error object to see Laravel validation messages
    console.error('Add Shipment Error:', err);
    console.log('Error Response Data:', err.response?.data);

    // Extract message(s)
    const msg = err.response?.data?.error || err.response?.data?.message || JSON.stringify(err.response?.data) || err.message;
    commit('setError', msg);

    if(this._vm?.$toast) this._vm.$toast.error('Failed to add shipment: ' + msg);
  } finally {
    commit('setLoading', false);
  }
}
,
    async updateShipmentAction({ commit }, shipment) {
      commit('setError', null);
      try {
        const res = await axios.put(`/api/shipments/${shipment.id}`, shipment);

        if (res.data?.error) {
          commit('setError', res.data.error);
          if(this._vm?.$toast) this._vm.$toast.error('Failed to update shipment: ' + JSON.stringify(res.data.error));
        } else {
          commit('updateShipment', res.data);
          if(this._vm?.$toast) this._vm.$toast.success('Shipment updated successfully!');
        }
      } catch(err) {
        const msg = err.response?.data?.error || err.response?.data?.message || err.message;
        commit('setError', msg);
        if(this._vm?.$toast) this._vm.$toast.error('Failed to update shipment: ' + msg);
        console.error('Update Shipment Error:', err);
      }
    },

    async deleteShipment({ commit }, id) {
      commit('setError', null);
      try {
        const res = await axios.delete(`/api/shipments/${id}`);
        if (res.data?.error) {
          commit('setError', res.data.error);
          if(this._vm?.$toast) this._vm.$toast.error('Failed to delete shipment: ' + JSON.stringify(res.data.error));
        } else {
          commit('removeShipment', id);
          if(this._vm?.$toast) this._vm.$toast.success('Shipment deleted successfully!');
        }
      } catch(err) {
        const msg = err.response?.data?.error || err.response?.data?.message || err.message;
        commit('setError', msg);
        if(this._vm?.$toast) this._vm.$toast.error('Failed to delete shipment: ' + msg);
        console.error('Delete Shipment Error:', err);
      }
    },

    toggleShipmentStatus({ commit, state }, id) {
      const shipment = state.shipments.find(s => s.id === id);
      if(shipment) {
        const newStatus = shipment.deliveryStatus === 'active' ? 'completed' : 'active';
        commit('updateShipment', { ...shipment, deliveryStatus: newStatus });
        if(this._vm?.$toast) this._vm.$toast.success(`Shipment marked as ${newStatus}`);
      }
    },

    async uploadShipmentImages({ commit }, { id, files }) {
      commit('setError', null);
      try {
        const formData = new FormData();
        files.forEach(file => formData.append('images[]', file));

        const res = await axios.post(`/api/shipments/${id}/images`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (res.data?.error) {
          commit('setError', res.data.error);
          if(this._vm?.$toast) this._vm.$toast.error('Failed to upload images: ' + JSON.stringify(res.data.error));
        } else {
          commit('addShipmentImages', { id, images: res.data });
          if(this._vm?.$toast) this._vm.$toast.success('Images uploaded successfully!');
        }
      } catch(err) {
        const msg = err.response?.data?.error || err.response?.data?.message || err.message;
        commit('setError', msg);
        if(this._vm?.$toast) this._vm.$toast.error('Failed to upload images: ' + msg);
        console.error('Upload Images Error:', err);
      }
    },
  },
};
